import {systemTrainerControllerGetByCompany} from "../../api/generated";

// Trainer reads for a SYSTEM_ADMIN, scoped to an EXPLICITLY chosen company. Backed by the server's
// SystemTrainerController (/system/trainer?companyId=...).
//
// Why this exists instead of ../TrainerService.getTrainers: /admin/trainer derives the company from
// the principal and its floor is ADMIN/TRAINER, so a company-less super-admin gets a 403 there —
// which is exactly what broke the import-users page the moment a company was picked. A super-admin
// picking a company is legitimate under /system/**, so the companyId travels as a query param.
//
// A company ADMIN/TRAINER must keep using ../TrainerService (their company comes from the token).

// Every trainer of the given company, already sorted by name server-side. Returns {data: [...]} so
// callers read `res.data` exactly like the /admin twin.
export async function getCompanyTrainers(companyId) {
  const {data, error} = await systemTrainerControllerGetByCompany({query: {companyId}});
  if (error) throw error;
  return {data: data ?? []};
}
